import _ from 'lodash';

import { useSettings } from '@/react/portainer/settings/queries';

type Option = {
  label: string;
  value: number;
};

type DefaultOption = Option & { isDefault: true };

export type Options = [DefaultOption, ...Option[]];

export function useIntervalOptions(
  fieldName:
    | 'Edge.PingInterval'
    | 'Edge.SnapshotInterval'
    | 'Edge.CommandInterval'
    | 'EdgeAgentCheckinInterval',
  initialOptions: Options,
  isDefaultHidden: boolean
) {
  const [{ value: defaultValue }] = initialOptions;

  const settingsQuery = useSettings(
    (settings) => _.get(settings, fieldName, 0) as number,
    !isDefaultHidden
  );

  if (isDefaultHidden) {
    return initialOptions.slice(1);
  }

  if (
    typeof settingsQuery.data !== 'undefined' &&
    settingsQuery.data !== defaultValue
  ) {
    let label = `${settingsQuery.data} seconds`;
    const option = initialOptions.find((o) => o.value === settingsQuery.data);
    if (option) {
      label = option.label;
    }

    return [
      {
        value: defaultValue,
        label: `Use default interval (${label})`,
      },
      ...initialOptions.slice(1),
    ];
  }

  return initialOptions;
}
